import {
  apiGetCart,
  apiAddToCart,
  apiDecrementCart,
  apiRemoveCartItem,
  apiClearCart,
} from "../../api/cart.api";
import { resolveProduct } from "../productIndex";
import { cartItemsToMap, buildLoginRequiredMessage } from "./session.helpers";

export async function syncCartFromServer({ setCart }) {
  const res = await apiGetCart();

  if (res?.unauthenticated) {
    setCart({});
    return { unauthenticated: true };
  }

  setCart(cartItemsToMap(res?.items || []));
  return res;
}

export async function handleAddToCart({
  action,
  productIndexRef,
  setCart,
  setMessages,
}) {
  const prod = resolveProduct(productIndexRef, action);
  const product = prod || action?.product || {};
  const productId = String(
    action?.product_id ||
      product?.id ||
      product?.product_id ||
      product?.variant_id ||
      ""
  );

  if (!productId) {
    setMessages((m) => [
      ...m,
      { role: "assistant", text: "⚠️ Не зміг додати товар у кошик" },
    ]);
    return { ok: false, reason: "invalid_product" };
  }

  try {
    const res = await apiAddToCart(
      { ...product, id: productId, product_id: productId },
      Number(action?.qty || 1)
    );

    if (res?.unauthenticated) {
      setMessages((m) => [...m, buildLoginRequiredMessage()]);
      return { ok: false, reason: "auth_required" };
    }

    setCart(cartItemsToMap(res?.items || []));
    return { ok: true };
  } catch (e) {
    console.error("add_to_cart error:", e);
    setMessages((m) => [
      ...m,
      { role: "assistant", text: "⚠️ Не зміг додати товар у кошик" },
    ]);
    return { ok: false, reason: "request_failed" };
  }
}

export async function handleDecrementCart({
  action,
  cart,
  setCart,
  setMessages,
}) {
  const productId = String(action?.product_id || "");
  if (!productId) return { ok: false, reason: "invalid_product" };

  try {
    const res = await apiDecrementCart(productId, Number(action?.qty || 1));

    if (res?.unauthenticated) {
      setMessages((m) => [...m, buildLoginRequiredMessage()]);
      return { ok: false, reason: "auth_required" };
    }

    setCart(cartItemsToMap(res?.items || []));
    return { ok: true };
  } catch (e) {
    console.error("decrement_cart error:", e);
    return { ok: false, reason: "request_failed" };
  }
}

export async function handleRemoveFromCart({
  action,
  cart,
  setCart,
  setMessages,
}) {
  const productId = String(action?.product_id || "");
  if (!productId) return { ok: false, reason: "invalid_product" };

  try {
    const res = await apiRemoveCartItem(productId);

    if (res?.unauthenticated) {
      setMessages((m) => [...m, buildLoginRequiredMessage()]);
      return { ok: false, reason: "auth_required" };
    }

    setCart(cartItemsToMap(res?.items || []));
    return { ok: true };
  } catch (e) {
    console.error("remove_from_cart error:", e);
    return { ok: false, reason: "request_failed" };
  }
}

export async function handleClearCart({ setCart, setMessages }) {
  try {
    const res = await apiClearCart();

    if (res?.unauthenticated) {
      setMessages((m) => [...m, buildLoginRequiredMessage()]);
      return { ok: false, reason: "auth_required" };
    }

    setCart({});
    return { ok: true };
  } catch (e) {
    console.error("clear_cart error:", e);
    return { ok: false, reason: "request_failed" };
  }
}